
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sorry",
      function () {
        return require("private-next-pages/sorry/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sorry"])
      });
    }
  